/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Search_ChatsInputs */

const en_mcp_demo_search_chats = /** @type {(inputs: Mcp_Demo_Search_ChatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search chats`)
};

const es_mcp_demo_search_chats = /** @type {(inputs: Mcp_Demo_Search_ChatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar chats`)
};

/**
* | output |
* | --- |
* | "Search chats" |
*
* @param {Mcp_Demo_Search_ChatsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_search_chats = /** @type {((inputs?: Mcp_Demo_Search_ChatsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Search_ChatsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_search_chats(inputs)
	return en_mcp_demo_search_chats(inputs)
});